import styled, { css } from "styled-components";

import { LoadingText } from "../HomeContent/style";

import { get, bigPhone } from "package-common-react/lib/style/util";
import NativeLegalButton from "package-common-react/lib/components/LegalButton";

export { LoadingText };

export const Layout = styled.div`
  background: ${get('color.background')} none center center/cover no-repeat;
  color: ${get("color.primaryText")};
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;

  ${new Array(20).fill(1).map(
    (value, index) => css`
  body.question-${index + 1} & {
    background-image: url("/assets/backgrounds/question-${(
      "" +
      (index + 1)
    ).padStart(2, "0")}.jpg");
  }
  `
  )};
  body.quiz-valid & {
    background-color: ${get("color.success")};
  }
  body.quiz-invalid & {
    background-color: ${get("color.yellow")};
  }
`;

export const Header = styled.header`
  background: transparent url("/assets/images/header-background.png") no-repeat
    top center;
  background-size: 100% 100%;

  align-items: flex-start;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 15px 25px 45px 25px;

  position: relative;
  z-index: 1000;
`;

export const ImageLogo = styled.img`
  height: 55px;
`;

export const Main = styled.main`
  flex: 1;
  overflow: auto;
  overflow-x: hidden;
  padding: 0 25px 10px 25px;
  
  ${bigPhone`
    padding-top: 10px;
  `};
`;

export const Footer = styled.footer``;

export const LegalButton = NativeLegalButton.extend`
  bottom: 25px;
  left: 25px;
  position: absolute;
`;



// WEBPACK FOOTER //
// ./src/components/MainLayout/style.js